export default "__VITE_ASSET__gqP6esOp__"